export const BOOKING_VARIANTS = ['confirmed', 'pending', 'unsolved', 'error', 'cancelled']

export const BOOKING_CONFIRMED = 'confirmed'
export const BOOKING_PENDING = 'pending'
export const BOOKING_UNSOLVED = 'unsolved'
export const BOOKING_ERROR = 'error'
export const BOOKING_CANCELLED = 'cancelled'
